import { createSlice } from "@reduxjs/toolkit";

/**
 * Slice del modulo Administracion Documental: filtro inducido que el
 * dashboard (Dashadoc) le pasa a la bandeja (Gesdocxx) al navegar.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-08-04
 */
const admindocSlice = createSlice({
  name: "admindoc",
  initialState: {
    bandejaEstado: null,
    bandejaEdad: null,
  },
  reducers: {
    setBandejaEstado: (state, action) => {
      state.bandejaEstado = action.payload;
    },
    // payload: { min, max, titulo } — rango de antiguedad en dias
    setBandejaEdad: (state, action) => {
      state.bandejaEdad = action.payload;
    },
    // Limpia ambos filtros inducidos (la bandeja ya los copio a su estado local)
    clearBandejaEstado: (state) => {
      state.bandejaEstado = null;
      state.bandejaEdad = null;
    },
  },
});

export const { setBandejaEstado, setBandejaEdad, clearBandejaEstado } = admindocSlice.actions;

export const getBandejaEstado = (state) => state.admindoc.bandejaEstado;
export const getBandejaEdad = (state) => state.admindoc.bandejaEdad;

export default admindocSlice.reducer;
